import React, { Component } from 'react';
import { connect } from 'react-redux';
import TableAjax from '../../сomponents/TableAjax';
import { push } from 'react-router-redux';
import { getListOfTasks } from '../../api/archive';
import { reopenArchiveTask } from '../../api/task';


import { find, path, propEq, clone, mergeDeepLeft } from 'ramda';
import { changeModalState } from '../../actions/modal';
import Preloader from '../../common/Preloader';
import ConfirmAction from '../../common/ConfirmAction';
import './style.css';
import hasAccess from "../../helpers/permissionChecker";
import { addNotification as notify } from "reapop";

import { fetchDetailsWithoutProperty } from '../../api/dashboard';
import fields from '../Dashboard/fields';
import CheckBox from '../../common/CheckBox';
import filterFields from './field';
import moment from 'moment';
import DatePicker from "../../common/DatePicker";

class ArchiveListWO extends Component {

  constructor(props) {
    super(props);
    this.onSearch = this.onSearch.bind(this);
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this);
    this.handlerReOpen = this.handlerReOpen.bind(this);
    this.handlerEdit = this.handlerEdit.bind(this);
    this.getArchive = this.getArchive.bind(this);
    this.onChangeCurrentPage = this.onChangeCurrentPage.bind(this);
    this.reloadArchive = this.reloadArchive.bind(this);
    this.setProjectFields = this.setProjectFields.bind(this);
    this.onSetField = this.onSetField.bind(this);
    this.changeFormValue = this.changeFormValue.bind(this);
    this.applyFilter = this.applyFilter.bind(this);
    this.getFilter = this.getFilter.bind(this);

    this.state = {
      items: Array.from([]),
      container: false,
      search: '',
      loading: true,
      itemsList: [],
      itemsCount: 0,
      itemsPerPage: 10,
      currentPage: 0,
      fields: [],
      selectedFields: [],
      filterFields: filterFields
    };

    this.columns = [
      'task_id',
      'name',
      'created',
      'description'
    ];

    this.columnNames = [
      'ID#',
      'PO#',
      'Created',
      'Description'
    ];
  }

  componentWillMount() {
    const { getStages } = this.props;
    getStages();
  }

  onSearch(search) {
    this.setState({ search }, () => {
      this.reloadArchive(true);
    });
  }

  setProjectFields(lanes) {
    let selectedIds = [];
    const projectFields = [ fields.search, {
      label: 'Unassigned',
      placeholder: '',
      system: {
        name: '',
      },
      value: true,
      errors: [],
      type: 'lanes',
      id: 0,
      name: 'project_' + 0,
      rules: {
        title: '',
        required: false,
      }
    }];
    for (let i = 0; i < lanes.length; i++) {
      let currentField = {
        label: lanes[i].label,
        placeholder: '',
        system: {
          name: '',
        },
        value: true,
        errors: [],
        id: lanes[i].id,
        type: 'lanes',
        name: 'project_' + lanes[i].id,
        rules: {
          title: '',
          required: false,
        }
      };

      selectedIds.push(lanes[i].id);

      projectFields.push(currentField);
    }
    this.setState({
      filters: true,
      selectedFields: selectedIds,
      fields: projectFields,
    });
  }

  changeFormValue(field, newObject) {
    let stateClone = clone(this.state);

    if (typeof field === 'object') {
      // FIX: add support of multiple levels
      stateClone.filterFields[field[0]][field[2]] = newObject;
    } else {
      stateClone.filterFields[field] = newObject;
    }

    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  getFilter() {
    let dateFrom = this.state.filterFields['filter_date_from'].value;
    let dateTo = this.state.filterFields['filter_date_to'].value;
    if (dateTo) {
      dateTo = moment(dateTo).format('M/D/YYYY');
    }

    if (dateFrom) {
      dateFrom = moment(dateFrom).format('M/D/YYYY');
    }

    return {
      filter_date_from: dateFrom || '1/1/1990',
      filter_date_to:  dateTo || moment().add('1', 'year').format('M/D/YYYY'),
    };
  }

  applyFilter() {
    this.reloadArchive(true);
  }

  onSetField(i, id, val) {
    const { fields } = this.state;
    const newField = [...fields];
    newField[i] = val;
    const selectedIds = [];
    for(let i = 0; i < newField.length; i ++) {
      if (newField[i].value) {
        selectedIds.push(newField[i].id)
      }
    }
    this.setState( { selectedFields: selectedIds, fields: [...newField]});
  }

  onChangeItemsPerPage(e) {
    e.preventDefault();
    this.setState({
      itemsPerPage: e.target.value,
    }, () => this.reloadArchive(true) );
    return false;
  }

  onChangeCurrentPage(currentPage) {
    this.setState({
      currentPage: currentPage,
    }, this.reloadArchive);
  }

  componentWillReceiveProps (newProps) {
    const itemsList = path(['archive', 'tasks'], newProps);
    const itemsCount = path(['archive', 'count'], newProps);
    const lanes = path(['dashboard', 'lanes'], newProps);

    if (this.state.fields.length === 0 && lanes) {
      this.setProjectFields(lanes);
    }

    if (itemsList) {
      this.setState({loading: false, itemsList, itemsCount});
    }
  }

  componentDidMount() {
    this.reloadArchive();
  }

  reloadArchive (reloadCurrentPage = false) {
    const { itemsPerPage, currentPage, selectedFields, search } = this.state;
    const newState = {loading: true, itemsList: [], itemsCount: 0};

    if (reloadCurrentPage) {
      newState.currentPage = 0;
    }

    const { filter_date_from, filter_date_to } = this.getFilter();

    this.setState({...newState});

    this.props.loadArchive({ selectedFields, itemsPerPage, search, currentPage, filter_date_from, filter_date_to  });
  }

  handlerReOpen(id) {
    this.props.handleModalState({
      isOpen: !this.props.modal.isOpen,
      handler: this.props.reopen,
      modalId: 'reopenWo',
      id: id,
    });
  }

  handlerEdit(id) {
    this.props.openTask(id);
  }

  getArchive() {
    // Get current role
    const { itemsList, itemsCount, currentPage, itemsPerPage, search} = this.state;

    /*if (!itemsList || itemsList.length === 0) {
      return null;
    }*/

    const itemActions = {
      reopen: {
        handler: this.handlerReOpen,
        itemId: 'task_id',
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa ion-android-refresh icon-stack-1x'],
        authorColumnName: 'user_id',
        permission: { 'permAreaKey': 'workOrder', 'permTypeKey': 'reOpen' },
        iconClass: 'remove_circle_outline',
        context: this,
        hasWrapper: true,
        title: 'reopen',
      },
      edit: {
        handler: this.handlerEdit,
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-pencil icon-stack-1x'],
        iconClass: '',
        authorColumnName: 'user_id',
        permission: { 'permAreaKey': 'workOrder', 'permTypeKey': 'view' },
        context: this,
        itemId: 'task_id',
        hasWrapper: true,
        title: 'edit',
      },
    };

    return (
      <div>
        <TableAjax
          onApplySearch={this.onSearch}
          items={itemsList}
          itemsCount={itemsCount}
          columns={this.columns}
          columnNames={this.columnNames}
          itemsPerPage={itemsPerPage}
          search={search}
          currentPage={currentPage}
          onChangeCurrentPage={this.onChangeCurrentPage}
          actions={itemActions}
          onSearch={this.onSearch}
          onChangeItemsPerPage={this.onChangeItemsPerPage}
        />
      </div>
    );
  }

  getProjects() {
    const projects = [];
    for (let i = 0; i < this.state.fields.length; i++) {

      if (this.state.fields[i].type === 'lanes') {

        projects.push(
            <div style={{
              display: 'inline-block',
              border: '1px solid rgba(0, 0, 0, 0.125)',
              borderRadius: '4px',
              padding: '5px',
              marginRight: '5px',
              marginBottom: '5px',
            }}>
              <CheckBox
                  customize={{
                    margin: '0',
                    paddingTop: '0',
                    paddingBottom: '0',
                  }}
                  key={i}
                  field={this.state.fields[i]}
                  onChange={(e, val)=>this.onSetField(i, this.state.fields[i].id, val)}
              />
            </div>
        );
      }
    }
    return projects;
  }

  render() {
    const { loading } = this.state;
    const archive = this.getArchive();
    let preloader = null;
    let linesPart = this.getProjects();
    if (loading) {
      preloader = (
        <Preloader
          show={true}
          type={'circle'}
        />
      );
    }

    return (
      <div className="card-block">
        <div className="clearfix mb-3">
          <button
            className="btn btn-rounded btn-icon ui-btn pull-right"
            onClick={this.applyFilter}
            style={{ marginRight: '10px', borderRadius: '4px', }}
          >
            <i className="fa fa-filter"></i>
            Apply filter
          </button>
        </div>
        <div style={{ paddingBottom: '10px' }}>
          <b>Projects:</b>
        </div>
        <div>
          {linesPart}
        </div>
        <div className="row">
          <div className="col col-md-6">
            <DatePicker
              field={this.state.filterFields['filter_date_from']}
              onChange={this.changeFormValue}
            />
          </div>
          <div className="col col-md-6">
            <DatePicker
              field={this.state.filterFields['filter_date_to']}
              onChange={this.changeFormValue}
            />
          </div>
        </div>
        {archive}
        {preloader}
        <ConfirmAction
          id={'reopenWo'}
          title={'Reopen Item'}
          content={'Are you sure you want to reopen this item?'}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    getStages: () => {
      fetchDetailsWithoutProperty()(dispatch);
    },
    loadArchive: (limits) => {
      getListOfTasks(limits)(dispatch);
    },
    handleModalState: (data) => {
      dispatch(changeModalState(data));
    },
    reopen: (id) => {
      reopenArchiveTask(id)(dispatch);
    },
    openTask: (id) => {
      dispatch(push('/pages/task/' + id));
    },
    accessDeniedMessage: () => {
      dispatch(notify({
        title: 'Reopen task',
        message: 'Access denied. Failed to reopen task.',
        status: 'error',
        position: 'tr',
        dismissible: true,
        dismissAfter: 3000
      }));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ArchiveListWO);



// WEBPACK FOOTER //
// ./src/containers/ArchiveListWO/index.js